import { API } from "aws-amplify";
import axios from "axios";
import { MissionReport, Pad, Route } from "../aircraft/types";

export const getRoutes = async (): Promise<Route[]> => {
  try {
    const res = await API.get("api", "/addressfind/list", {});
    return res;
  } catch (err) {
    throw err;
  }
};
export const getCassettes = async (): Promise<any> => {
  try {
    const res = await axios.get("https://flightlogger.manna.aero/cassettes", {
      headers: { "x-api-key": "FFEeXqlQ5I3x9UNy9OAeL8amqqZGBzmf54aAnoyb" },
    });

    return res.data;
  } catch (err) {
    throw err;
  }
};

export const sendMissionReport = async (
  missionReport: MissionReport
): Promise<any> => {
  try {
    const res = await API.post("depot", `/flightmetadata`, {
      body: missionReport,
    });
    return res;
  } catch (err) {
    throw err;
  }
};

export const sendGcsReport = async (
  missionReport: MissionReport
): Promise<any> => {
  try {
    const res = await API.post("depot", `/flightmetadata`, {
      body: missionReport,
    });
    return res;
  } catch (err) {
    throw err;
  }
};

export const generateMission = async (
  orderId: string,
  uavId: string,
  pos: [number, number]
): Promise<any> => {
  try {
    const res = await API.post(
      "core",
      `/mission?orderId=${orderId}&uavId=MNA-${uavId}&latitude=${pos[0]}&longitude=${pos[1]}`,
      {
        responseType: "json",
      }
    );
    return res;
  } catch (err) {
    throw err;
  }
};
export const getMission = async (missionId: string): Promise<any> => {
  try {
    const res = await API.get("core", `/mission/${missionId}`, {
      responseType: "json",
    });
    return res;
  } catch (err) {
    throw err;
  }
};

export const getPadStatus = async (
  latitude: number,
  longitude: number
): Promise<any> => {
  try {
    const res = await API.get(
      "core",
      `/mission/landingPad/${latitude}/${longitude}/?fullObject=true`,
      {
        responseType: "json",
      }
    );
    return res;
  } catch (err) {
    throw err;
  }
};
